module.exports = __webpack_public_path__ + "img/12_57.74bac695.png";